'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function CarouselWall({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'absolute -left-[1000px] top-0 z-[30] h-full w-[1000px] cursor-context-menu bg-white',
        className,
      )}
    />
  );
}
